import React, { useState } from 'react';
import Button from '../common/Button';
import CardPriceList from '../card/CardPriceList';
import CardPrice from '../card/CardPrice';
import CardImage from '../card/CardImage';
import RemoveFromWishlistButton from './RemoveFromWishlistButton';
import AddToCollectionButton from '../collection/AddToCollectionButton';
import cardUtils from '../../utils/cardUtils';

const CardWishlistItem = props => {
  const [allPrices, setAllPrices] = useState(false);
  const [allPricesButton, setAllPricesButton] = useState(
    'Mostrar más opciones',
  );
  const [allPricesButtonSign, setAllPricesButtonSign] =
    useState('fas fa-plus ml-2');

  return (
    <div key={props.card.name} className="w-full">
      <div className="flex flex-col bg-mediumColor shadow-md rounded-lg text-gray-700 p-4 gap-y-2">
        <div className="flex flex-col gap-y-2">
          <h4 className="text-xl text-center text-white">{props.card.name}</h4>
          <CardImage card={props.card} />
          <RemoveFromWishlistButton
            card={props.card}></RemoveFromWishlistButton>
          <AddToCollectionButton card={props.card} />
        </div>

        {cardUtils.sortPrices(props.card.cardPrices)[0] && (
          <div className="flex flex-col gap-y-2">
            <h4 className="text-lg font-semibold text-center text-white">
              Mejor precio
            </h4>
            <CardPrice
              card={props.card}
              price={cardUtils.sortPrices(props.card.cardPrices)[0]}
              addToCart={true}
            />
            {cardUtils.sortPrices(props.card.cardPrices)[1] && (
              <Button
                className="w-full"
                iconClass={allPricesButtonSign}
                onClick={() => {
                  setAllPrices(!allPrices);
                  if (allPrices) {
                    setAllPricesButton('Mostrar más opciones');
                    setAllPricesButtonSign('fas fa-plus ml-2 align-middle');
                  } else {
                    setAllPricesButton('Mostrar menos opciones');
                    setAllPricesButtonSign('fas fa-minus ml-2 align-middle');
                  }
                }}>
                {allPricesButton}
              </Button>
            )}
          </div>
        )}

        {cardUtils.sortPrices(props.card.cardPrices)[1] && allPrices && (
          <CardPriceList
            card={props.card}
            prices={cardUtils.sortPrices(props.card.cardPrices).slice(1)}
          />
        )}
      </div>
    </div>
  );
};

export default CardWishlistItem;
